export default {
    methods: {
        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
        }
    }
}
